export const BASE_URL = "https://hv12.tech3art.com";
// export const BASE_URL = "http://localhost:8000";